webpackJsonp([170786371021445],{

/***/ 797:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. I will answer to the message as soon as possible.</p>","frontmatter":{"title":"Success"}},"footnote":{"id":"/opt/build/repo/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>this is a demo site of the <a href=\"https://github.com/restry/gatsby-starter-personal-blog\">gatsby-starter-personal-blog</a></li>\n<li>built by <a href=\"https://www.restry.cn\">restry liu</a></li>\n<li>GatsbyJS, ReactJs, CSS in JS - <a href=\"https://dev.restry.cn\">Front-end web development with Restry</a></li>\n<li>deliverd by <a href=\"https://www.netlify.com/\">Netlify</a></li>\n<li>photos by <a href=\"https://unsplash.com\">unsplash.com</a></li>\n</ul>"},"site":{"siteMetadata":{"facebook":{"appId":""}}}},"pathContext":{"slug":"/success/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---success-18066ae71b0d1b2dd07f.js